<template>
  <b-sidebar
    id="sidebar-create-additional-exam"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Additional Exam') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="additionalExamCreate">

          <b-form-group
            :label="$t('Subject')"
            label-for="subject"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Subject')"
              rules="required"
            >
              <v-select
                id="period"
                v-model="additionalExam.subject"
                :reduce="(option) => option.id"
                :options="additionalExamSubjects"
                :get-option-label="(option) => $langName(option)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            :label="$t('Exam date')"
            label-for="subject"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Exam date')"
              rules="required"
            >
              <flat-pickr
                v-model="additionalExam.exam_date"
                class="form-control"
                :config="{ dateFormat: 'Y-m-d'}"
                placeholder="YYYY-MM-DD"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Short info -->
          <b-form-group
            :label="$t('Comment')"
            label-for="comment"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Comment')"
              rules=""
            >
              <b-form-textarea
                id="comment"
                v-model="additionalExam.comment"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Period -->
          <b-form-group
            :label="$t('Period')"
            label-for="period"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Period')"
              rules="required"
            >
              <v-select
                id="period"
                v-model="additionalExam.period"
                :reduce="(option) => option.id"
                :options="periods"
                :get-option-label="(option) => option.admission_year"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="additionalExam.id ? 'primary' : 'success'"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ additionalExam.id ? $t('Update') : $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup,
  BButton, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormTextarea,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    additionalExam() {
      return this.$store.state[this.MODULE_NAME].additionalExam
    },
    periods() {
      return this.$store.state.staticModule.periodList
    },
    additionalExamSubjects() {
      return this.$store.state.staticModule.additionalExamSubjects
    },
  },
  mounted() {
    this.$store.dispatch('staticModule/periodList')
    localize(this.$i18n.locale)
    this.freshData()
  },
  methods: {
    clear(hide) {
      this.freshData()
      hide()
    },
    freshData() {
      this.$store.commit('additionalExam/GET', {})
      this.$refs.additionalExamCreate.reset()
    },
    submit(hide) {
      this.$refs.additionalExamCreate.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.additionalExam, `additionalExam/${this.additionalExam.id ? 'patch' : 'create'}`, () => {
            this.$emit('refetchData')
            this.freshData()
          })
          hide()
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'additionalExam'
    return {
      MODULE_NAME,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
